// src/lib/svg/shapes.js Shared path data generators for rect and ellipse shapes. Used by Stage/CreateTool (Konva) and SVGOverlay/SVGCreateTool (PixiJS).

export const getEllipsePathData = (x, y, width, height) => {
	const cx = Math.round((x + width / 2) * 10) / 10
	const cy = Math.round((y + height / 2) * 10) / 10
	const rx = Math.round((Math.abs(width) / 2) * 10) / 10
	const ry = Math.round((Math.abs(height) / 2) * 10) / 10
	const c = 0.551915024494
	const cxr = Math.round(rx * c * 10) / 10
	const cyr = Math.round(ry * c * 10) / 10

	return [
		`M${cx},${cy - ry}`,
		`C${cx + cxr},${cy - ry} ${cx + rx},${cy - cyr} ${cx + rx},${cy}`,
		`C${cx + rx},${cy + cyr} ${cx + cxr},${cy + ry} ${cx},${cy + ry}`,
		`C${cx - cxr},${cy + ry} ${cx - rx},${cy + cyr} ${cx - rx},${cy}`,
		`C${cx - rx},${cy - cyr} ${cx - cxr},${cy - ry} ${cx},${cy - ry}Z`,
	].join('')
}

export const getRectPathData = (x, y, w, h) => {
	const r = v => Math.round(v * 10) / 10
	const x2 = r(x + w),
		y2 = r(y + h)
	x = r(x)
	y = r(y)
	return [
		`M${x},${y}`,
		`C${x},${y} ${x2},${y} ${x2},${y}`,
		`C${x2},${y} ${x2},${y2} ${x2},${y2}`,
		`C${x2},${y2} ${x},${y2} ${x},${y2}`,
		`C${x},${y2} ${x},${y} ${x},${y}Z`,
	].join('')
}
